<form [formGroup]="formGroup">
    <nuc-form-field label="Move items to step">
        <nuc-dropdown [items]="stepOptions"
                      [total]="0"
                      [nullOption]="false"
                      formControlName="destinationStep"
                      placeholder="Move items to step"/>
    </nuc-form-field>
</form>
